'use client';

import { createContext, useContext, type ReactNode } from 'react';

interface ModelsContextValue {
  // Reserved for future suite-wide coordination. Model data lives in React Query.
}

const ModelsContext = createContext<ModelsContextValue | null>(null);

export function ModelsProvider({ children }: { children: ReactNode }) {
  return <ModelsContext.Provider value={{}}>{children}</ModelsContext.Provider>;
}

export function useModelsContext(): ModelsContextValue {
  const ctx = useContext(ModelsContext);
  if (!ctx) throw new Error('ModelsProvider not mounted');
  return ctx;
}
